<template>
  <div class="app-container erp-sync-page">
    <el-row :gutter="16" class="top-row">
      <el-col :xs="24" :md="12">
        <div class="panel config-panel" v-loading="configLoading">
          <div class="panel-title">
            <span>聚水潭配置</span>
            <el-tag size="mini" :type="config.env === 'prod' ? 'success' : 'warning'">
              {{ config.env || "未配置" }}
            </el-tag>
          </div>
          <el-descriptions :column="2" size="small" border>
            <el-descriptions-item label="接口地址">{{
              config.apiHost || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="店铺ID">{{
              config.jstShopId || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="AppKey">{{ config.appKey || "-" }}</el-descriptions-item>
            <el-descriptions-item label="AccessToken">{{
              config.accessToken || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="RefreshToken">{{
              config.refreshToken || "-"
            }}</el-descriptions-item>
            <el-descriptions-item label="刷新接口">{{
              config.refreshApiPath || "-"
            }}</el-descriptions-item>
          </el-descriptions>
          <div class="panel-actions">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-refresh"
              :loading="tokenLoading"
              @click="handleRefreshToken"
            >
              刷新 Token
            </el-button>
            <el-button size="small" icon="el-icon-refresh-right" @click="loadConfig"
              >重新读取配置</el-button
            >
          </div>
        </div>
      </el-col>

      <el-col :xs="24" :md="12">
        <div class="panel summary-panel" v-loading="summaryLoading">
          <div class="panel-title">
            <span>同步概览</span>
            <el-button type="text" icon="el-icon-refresh" @click="loadSummary">刷新</el-button>
          </div>
          <div class="summary-grid">
            <div class="summary-item">
              <div class="summary-value">{{ summary.pending || 0 }}</div>
              <div class="summary-label">待同步</div>
            </div>
            <div class="summary-item success">
              <div class="summary-value">{{ summary.success || 0 }}</div>
              <div class="summary-label">成功</div>
            </div>
            <div class="summary-item danger">
              <div class="summary-value">{{ summary.failed || 0 }}</div>
              <div class="summary-label">失败</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="panel operation-panel">
      <div class="panel-title">
        <span>手动同步</span>
        <span class="panel-tip">用于补偿单条数据或立即执行一批待同步任务</span>
      </div>
      <el-row :gutter="12">
        <el-col :xs="24" :lg="8">
          <div class="operation-block">
            <div class="operation-title">订单</div>
            <el-input v-model="forms.orderId" size="small" placeholder="商城订单ID" clearable />
            <div class="button-line">
              <el-button
                size="small"
                type="primary"
                :loading="actionLoading.order"
                @click="runAction('order')"
                >推送订单</el-button
              >
              <el-button
                size="small"
                :loading="actionLoading.delivery"
                @click="runAction('delivery')"
                >同步发货</el-button
              >
              <el-button
                size="small"
                :loading="actionLoading.reconcileOrder"
                @click="runAction('reconcileOrder')"
                >订单对账</el-button
              >
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :lg="8">
          <div class="operation-block">
            <div class="operation-title">商品</div>
            <el-input v-model="forms.goodsId" size="small" placeholder="商城商品ID" clearable />
            <div class="button-line">
              <el-button
                size="small"
                type="primary"
                :loading="actionLoading.goods"
                @click="runAction('goods')"
                >推送商品</el-button
              >
              <el-button
                size="small"
                :loading="actionLoading.importGoods"
                @click="importDialogVisible = true"
                >从聚水潭导入</el-button
              >
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :lg="8">
          <div class="operation-block">
            <div class="operation-title">售后与批量补偿</div>
            <el-input v-model="forms.afterId" size="small" placeholder="商城售后单ID" clearable />
            <div class="button-line">
              <el-button
                size="small"
                type="primary"
                :loading="actionLoading.afterSale"
                @click="runAction('afterSale')"
                >推送售后</el-button
              >
              <el-button
                size="small"
                :loading="actionLoading.reconcileAfterSale"
                @click="runAction('reconcileAfterSale')"
                >售后对账</el-button
              >
            </div>
            <div class="button-line">
              <el-button
                size="small"
                :loading="actionLoading.pendingOrder"
                @click="runAction('pendingOrder')"
                >补推待发货订单</el-button
              >
              <el-button
                size="small"
                :loading="actionLoading.pendingDelivery"
                @click="runAction('pendingDelivery')"
                >补推已发货订单</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="panel record-panel">
      <div class="filter-container">
        <el-select
          v-model="listQuery.bizType"
          placeholder="业务类型"
          class="filter-item w-130"
          clearable
        >
          <el-option label="订单" value="ORDER" />
          <el-option label="商品" value="GOODS" />
          <el-option label="发货" value="DELIVERY" />
          <el-option label="售后" value="AFTERSALE" />
          <el-option label="类目" value="CATEGORY" />
        </el-select>
        <el-select
          v-model="listQuery.status"
          placeholder="同步状态"
          class="filter-item w-120"
          clearable
        >
          <el-option label="待同步" :value="0" />
          <el-option label="成功" :value="1" />
          <el-option label="失败" :value="2" />
        </el-select>
        <el-input
          v-model="listQuery.action"
          placeholder="动作"
          class="filter-item w-180"
          clearable
        />
        <el-input
          v-model="listQuery.bizNo"
          placeholder="业务单号"
          class="filter-item w-200"
          clearable
        />
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
          >搜索</el-button
        >
        <el-button class="filter-item" icon="el-icon-refresh-right" @click="resetFilter"
          >重置</el-button
        >
      </div>

      <el-table v-loading="listLoading" :data="list" size="small" border fit highlight-current-row>
        <el-table-column label="ID" prop="id" width="80" align="center" />
        <el-table-column label="业务类型" prop="bizType" width="100" align="center">
          <template slot-scope="scope">{{ bizTypeText(scope.row.bizType) }}</template>
        </el-table-column>
        <el-table-column label="业务ID" prop="bizId" width="100" align="center" />
        <el-table-column label="业务单号" prop="bizNo" min-width="170" show-overflow-tooltip />
        <el-table-column label="动作" prop="action" min-width="170" show-overflow-tooltip />
        <el-table-column label="状态" prop="status" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="mini">{{
              statusText(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="ERP单号" prop="erpNo" min-width="120" show-overflow-tooltip />
        <el-table-column label="失败原因" prop="errorMsg" min-width="220" show-overflow-tooltip />
        <el-table-column label="同步时间" prop="lastSyncTime" width="170" align="center">
          <template slot-scope="scope">{{ formatApiDate(scope.row.lastSyncTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openRecord(scope.row)">详情</el-button>
            <el-button
              v-if="scope.row.status === 2"
              type="text"
              size="mini"
              :loading="!!retryingRecordIds[scope.row.id]"
              @click="handleRetry(scope.row)"
              >重推</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="listQuery.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog title="同步记录详情" :visible.sync="recordDialogVisible" width="760px">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="业务类型">{{
          bizTypeText(currentRecord.bizType)
        }}</el-descriptions-item>
        <el-descriptions-item label="动作">{{ currentRecord.action || "-" }}</el-descriptions-item>
        <el-descriptions-item label="业务ID">{{ currentRecord.bizId || "-" }}</el-descriptions-item>
        <el-descriptions-item label="业务单号">{{
          currentRecord.bizNo || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{
          statusText(currentRecord.status)
        }}</el-descriptions-item>
        <el-descriptions-item label="错误">{{
          currentRecord.errorMsg || "-"
        }}</el-descriptions-item>
      </el-descriptions>
      <div class="json-title">请求报文</div>
      <pre class="json-box">{{ prettyJson(currentRecord.requestBody) }}</pre>
      <div class="json-title">响应报文</div>
      <pre class="json-box">{{ prettyJson(currentRecord.responseBody) }}</pre>
    </el-dialog>

    <el-dialog
      title="从聚水潭导入商品"
      :visible.sync="importDialogVisible"
      width="620px"
      :close-on-click-modal="false"
    >
      <el-alert
        title="不填写条件时按后端默认规则导入，填写时请输入聚水潭查询 JSON"
        type="info"
        show-icon
        :closable="false"
        class="import-alert"
      />
      <el-input
        v-model="importJson"
        type="textarea"
        :rows="8"
        placeholder='例如：{"page_index":1,"page_size":50}'
      />
      <div slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="actionLoading.importGoods" @click="runImportGoods"
          >开始导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getJstConfig,
  getJstRecordList,
  getJstRecordSummary,
  importJstGoods,
  reconcileJstAfterSales,
  reconcileJstOrders,
  refreshJstToken,
  retryJstRecord,
  syncJstAfterSale,
  syncJstDelivery,
  syncJstGoods,
  syncJstOrder,
  syncPendingJstDelivery,
  syncPendingJstOrders
} from "@/api/erp";
import { formatApiDate } from "@/utils/utils";

export default {
  name: "ErpSyncCenter",
  data() {
    return {
      config: {},
      summary: {},
      list: [],
      total: 0,
      configLoading: false,
      summaryLoading: false,
      listLoading: false,
      tokenLoading: false,
      recordDialogVisible: false,
      importDialogVisible: false,
      importJson: "",
      currentRecord: {},
      retryingRecordIds: {},
      forms: {
        orderId: "",
        goodsId: "",
        afterId: ""
      },
      actionLoading: {
        order: false,
        delivery: false,
        pendingOrder: false,
        pendingDelivery: false,
        reconcileOrder: false,
        goods: false,
        importGoods: false,
        afterSale: false,
        reconcileAfterSale: false
      },
      listQuery: {
        page: 1,
        pageSize: 20,
        bizType: "",
        status: null,
        action: "",
        bizNo: ""
      }
    };
  },
  created() {
    this.loadConfig();
    this.loadSummary();
    this.getList();
  },
  methods: {
    formatApiDate,
    loadConfig() {
      this.configLoading = true;
      getJstConfig()
        .then(response => {
          this.config = response.data || {};
        })
        .finally(() => {
          this.configLoading = false;
        });
    },
    loadSummary() {
      this.summaryLoading = true;
      getJstRecordSummary()
        .then(response => {
          this.summary = response.data || {};
        })
        .finally(() => {
          this.summaryLoading = false;
        });
    },
    getList() {
      this.listLoading = true;
      getJstRecordList(this.listQuery)
        .then(response => {
          const data = response.data || {};
          this.list = data.entitys || [];
          this.total = data.totalCount || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        bizType: "",
        status: null,
        action: "",
        bizNo: ""
      };
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleRefreshToken() {
      this.tokenLoading = true;
      refreshJstToken()
        .then(response => {
          if (response.bizcode === 100) {
            this.$message.success("Token 刷新成功");
            this.config = response.data || {};
          }
        })
        .finally(() => {
          this.tokenLoading = false;
        });
    },
    runAction(type) {
      const actionMap = {
        order: {
          field: "orderId",
          message: "请输入商城订单ID",
          request: () => syncJstOrder(this.forms.orderId)
        },
        delivery: {
          field: "orderId",
          message: "请输入商城订单ID",
          request: () => syncJstDelivery(this.forms.orderId)
        },
        pendingOrder: {
          request: () => syncPendingJstOrders(50)
        },
        pendingDelivery: {
          request: () => syncPendingJstDelivery(50)
        },
        reconcileOrder: {
          request: () => reconcileJstOrders(50)
        },
        goods: {
          field: "goodsId",
          message: "请输入商城商品ID",
          request: () => syncJstGoods(this.forms.goodsId)
        },
        afterSale: {
          field: "afterId",
          message: "请输入商城售后单ID",
          request: () => syncJstAfterSale(this.forms.afterId)
        },
        reconcileAfterSale: {
          request: () => reconcileJstAfterSales(50)
        }
      };
      const action = actionMap[type];
      if (!action) return;
      if (action.field && !this.forms[action.field]) {
        this.$message.warning(action.message);
        return;
      }
      this.actionLoading[type] = true;
      action
        .request()
        .then(response => {
          if (response.bizcode === 100) {
            this.$message.success("操作已执行");
            this.loadSummary();
            this.getList();
          }
        })
        .finally(() => {
          this.actionLoading[type] = false;
        });
    },
    runImportGoods() {
      let params = {};
      if (this.importJson && this.importJson.trim()) {
        try {
          params = JSON.parse(this.importJson);
        } catch (e) {
          this.$message.warning("请输入合法 JSON");
          return;
        }
      }
      this.actionLoading.importGoods = true;
      importJstGoods(params)
        .then(response => {
          if (response.bizcode === 100) {
            this.$message.success("导入任务已执行");
            this.importDialogVisible = false;
            this.loadSummary();
            this.getList();
          }
        })
        .finally(() => {
          this.actionLoading.importGoods = false;
        });
    },
    openRecord(row) {
      this.currentRecord = row || {};
      this.recordDialogVisible = true;
    },
    handleRetry(row) {
      if (!row || !row.id || row.status !== 2 || this.retryingRecordIds[row.id]) return;
      this.$set(this.retryingRecordIds, row.id, true);
      retryJstRecord(row.id)
        .then(response => {
          if (response.bizcode === 100) {
            const data = response.data || {};
            this.$message.success(data.message || "重推任务已执行");
            this.loadSummary();
            this.getList();
          }
        })
        .finally(() => {
          this.$delete(this.retryingRecordIds, row.id);
        });
    },
    prettyJson(value) {
      if (!value) return "-";
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    },
    bizTypeText(value) {
      const map = {
        ORDER: "订单",
        GOODS: "商品",
        DELIVERY: "发货",
        AFTERSALE: "售后",
        CATEGORY: "类目"
      };
      return map[value] || value || "-";
    },
    statusText(value) {
      const map = {
        0: "待同步",
        1: "成功",
        2: "失败",
        3: "处理中"
      };
      return map[value] || "-";
    },
    statusTag(value) {
      if (value === 1) return "success";
      if (value === 2) return "danger";
      return "info";
    }
  }
};
</script>

<style scoped lang="scss">
.erp-sync-page {
  .top-row {
    margin-bottom: 14px;
  }

  .panel {
    margin-bottom: 14px;
    padding: 16px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  .panel-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
  }

  .panel-tip {
    color: #909399;
    font-size: 13px;
    font-weight: 400;
  }

  .panel-actions {
    margin-top: 14px;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .summary-item {
    padding: 18px 12px;
    text-align: center;
    background: #f5f7fa;
    border-radius: 4px;
  }

  .summary-item.success {
    background: #f0f9eb;
  }

  .summary-item.danger {
    background: #fef0f0;
  }

  .summary-value {
    color: #303133;
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
  }

  .summary-label {
    margin-top: 6px;
    color: #606266;
    font-size: 13px;
  }

  .operation-block {
    min-height: 128px;
    padding: 14px;
    background: #f8fafc;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  .operation-title {
    margin-bottom: 10px;
    color: #303133;
    font-weight: 600;
  }

  .button-line {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  .button-line .el-button + .el-button {
    margin-left: 0;
  }

  .w-120 {
    width: 120px;
  }

  .w-130 {
    width: 130px;
  }

  .w-180 {
    width: 180px;
  }

  .w-200 {
    width: 200px;
  }

  .json-title {
    margin: 14px 0 6px;
    color: #303133;
    font-weight: 600;
  }

  .json-box {
    max-height: 220px;
    margin: 0;
    padding: 12px;
    overflow: auto;
    color: #303133;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
  }

  .import-alert {
    margin-bottom: 12px;
  }
}
</style>
